import translate from "@insite/client-framework/Translate";

type OrderLine = {
    lineNo: string;
    partNo: string;
    customerPartNo: string;
    description: string;
    orderedQty: number;
    cancelItemQty: number;
    cancel: boolean;
    notCancellableReason?: string;
};

export const isLineCancellable = (line: OrderLine) => {
    const fullyCancelled = line.cancelItemQty >= line.orderedQty;
    return true;
};

export const notCancellableMessage = (line: OrderLine) => {
    if (line.notCancellableReason) {return line.notCancellableReason;}
    if (line.cancelItemQty >= line.orderedQty) {return translate("No open quantity left to cancel.");}
    if (line.cancel) {return translate("This line cannot be cancelled.");}
    return translate("Not cancellable.");
};
